import React, {useEffect, useRef, useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {FaEdit, FaPlus} from "react-icons/fa";
import { toast } from "react-toastify";
import Grid from "../components/Grid";
import imageCompression from "browser-image-compression";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

function TransactionPage({ handleContentChange }) {

    const [data, setData] = useState([]);
    const [categories,setCategories] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [previewFile, setPreviewFile] = useState(null);
    const [showCashbookPrompt, setShowCashbookPrompt] = useState(false);
    const [selectedCategoryForPrompt, setSelectedCategoryForPrompt] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [expandedUser, setExpandedUser] = useState(null);
    const [expandedRow, setExpandedRow] = useState({});
    const [userTransactions, setUserTransactions] = useState([]);
    const [userTotal, setUserTotal] = useState(0);
    const [cashbookStatus, setCashbookStatus] = useState({
        hasCashBook: true,
        hasPendingRequest: false
    });
    const [categoryStatusMap, setCategoryStatusMap] = useState({});
    const [showDropdown, setShowDropdown] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });
    const [totalRows, setTotalRows] = useState(0);
    const [filters, setFilters] = useState({
        search: "",
        type: "",
        from: "",
        to: "",
        category: ""
    });

    const [formData, setFormData] = useState({
        id:"",
        category: "",
        type: "Payment",
        amount: "",
        description: "",
        attachments: []
    });

    console.log(formData);

    const token = sessionStorage.getItem("token");
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const role = user?.role || "";

    const isAdminView = ["Company Admin", "Accountant"].includes(role);

    const navigate = useNavigate();

    useEffect(() => {
        if (isAdminView) {
            fetchUsers();
        } else {
            fetchTransactions();
        }
    }, [paginationModel]);

    useEffect(() => {
        fetchCategories();
    }, []);


    useEffect(() => {
        return () => {
            previewImages.forEach(img => {
                if (img) URL.revokeObjectURL(img);
            });
        };
    }, [previewImages]);

    useEffect(() => {
        if (categories.length > 0) {
            fetchCategoryStatuses();
        }
    }, [categories]);

    useEffect(() => {
        if (!isAdminView) {
            fetchTransactions();
        }
    }, [paginationModel, filters]);

    const fetchTransactions = async () => {
        try {

            const params = new URLSearchParams();

            params.append("page", paginationModel.page + 1);
            params.append("limit", paginationModel.pageSize);

            if (filters.search) {
                params.append("search", filters.search);
            }

            params.append("user_view", "true");

            if (filters.category) {
                params.append("category", filters.category);
            }

            if (filters.from) {
                params.append("startDate", filters.from);
            }

            if (filters.to) {
                params.append("endDate", filters.to);
            }

            const res = await axios.get(
                `${API_BASE_URL}/pettycash/get-transactions?${params.toString()}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setData(res.data.data || []);
            setTotalRows(res.data.totalRecords || 0);

        } catch {
            toast.error("Failed to load transactions");
        }
    };

    const fetchCategories = async()=>{

        try{

            const res = await axios.get(
                `${API_BASE_URL}/cashbook-category/get`,
                {headers:{Authorization:`Bearer ${token}`}}
            );

            setCategories(res.data.data || []);

        }catch(err){

            toast.error("Error loading categories");

        }

    };

    const fetchUsers = async () => {
        try {
            const res = await axios.get(
                `${API_BASE_URL}/pettycash/admin/users`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setData(res.data.data || []);
        } catch {
            toast.error("Failed to load users");
        }
    };
    const handledAddClick = () => {
        setIsEdit(false);

        setFormData({
            id:"",
            category: "",
            type: "Payment",
            amount: "",
            description: "",
            attachments: []
        });

        setShowModal(true);
    }

    const fetchCategoryStatuses = async () => {
        const statusMap = {};

        for (const cat of categories) {
            try {
                const res = await axios.get(
                    `${API_BASE_URL}/cashbook/check?category=${cat._id}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (res.data.hasCashBook) {
                    statusMap[cat._id] = "Active";
                } else if (res.data.hasPendingRequest) {
                    statusMap[cat._id] = "Pending";
                } else {
                    statusMap[cat._id] = "Missing";
                }

            } catch (err) {
                statusMap[cat._id] = "Missing";
            }
        }

        setCategoryStatusMap(statusMap);
    };

    const fetchUserTransactions = async (userId,pageNumber = 1) => {
        try {
            setLoadingMore(true);
            const res = await axios.get(
                `${API_BASE_URL}/pettycash/get-transactions?user=${userId}&page=${pageNumber}&limit=10`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const newData = res.data.data || [];
            const total = res.data.totalRecords || 0;
            setUserTotal(total);
            if (pageNumber === 1) {
                setUserTransactions(newData);
            } else {
                setUserTransactions(prev => {
                    const merged = [...prev, ...newData];

                    if (merged.length >= total) {
                        setHasMore(false);
                    }

                    return merged;
                });
            }

            if (newData.length === 0) {
                setHasMore(false);
            }

            if (userTransactions.length + newData.length >= userTotal) {
                setHasMore(false);
            }
        } catch {
            toast.error("Failed to load user transactions");
        }finally {
            setLoadingMore(false);
        }
    };
    const containerRef = useRef();
    const pageRef = useRef(1);

    const handleUserRowClick = async (row) => {
        if (expandedUser === row._id) {
            setExpandedUser(null);
            return;
        }

        setExpandedUser(row._id);
        setPage(1);
        pageRef.current = 1;
        setUserTransactions([]);
        setHasMore(true);
        await fetchUserTransactions(row._id);
    };


    const handleScroll = () => {
        const el = containerRef.current;

        if (!el || loadingMore || !hasMore) return;

        const reachedBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

        if (reachedBottom) {
            pageRef.current += 1;
            fetchUserTransactions(expandedUser, pageRef.current);
        }
    };

    const handleEdit = (row) => {
        setIsEdit(true);

        setFormData({
            id:row._id,
            category: row.category?._id || "",
            type: row.transaction_type === "CashInvoice" ? "Payment" : "Receipt",
            amount: row.amount,
            description: row.description,
            attachments: []
        });

        setShowModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log("CHANGE:", name, value);

        setFormData( prev => ({
            ...prev,
            [name]: value
        }));
    };

    const rowsWithExpand = data.flatMap(row => {
        if (expandedRow[row._id]) {
            return [
                row,
                {
                    ...row,
                    _id: row._id + "_expanded",
                    isExpandedRow: true,
                    parent: row,
                    className: "expanded-row"
                }
            ];
        }
        return [row];
    });

    const updateFilter = (newFilters) => {
        setPaginationModel(prev => ({ ...prev, page: 0 }));
        setFilters(prev => ({ ...prev, ...newFilters }));
    };

    const validTypes = [
        "image/jpeg",
        "image/png",
        "image/webp",
        "application/pdf"
    ];

    const handleFiles = async (files) => {

        const filtered = files.filter(file => validTypes.includes(file.type));

        if (filtered.length !== files.length) {
            toast.error("Only images and PDFs allowed");
        }

        const compressed = await Promise.all(
            filtered.map(async file => {
                if (file.type.startsWith("image/")) {
                    return await imageCompression(file, {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 800
                    });
                }
                return file;
            })
        );

        setFormData(prev => ({
            ...prev,
            attachments: [...prev.attachments, ...compressed]
        }));

        const previews = compressed.map(file =>
            file.type.startsWith("image/")
                ? URL.createObjectURL(file)
                : null
        );

        setPreviewImages(prev => [...prev, ...previews]);
    };

    const handleSubmit = async () => {
        try {
            if (!formData.category || !formData.amount || formData.amount <= 0) {
                return toast.error("Category, type and amount required");
            }

            const form = new FormData();

            form.append("category", formData.category);
            form.append("type", formData.type);
            form.append("amount", formData.amount);
            form.append("description", formData.description);

            formData.attachments.forEach(file => {
                form.append("attachments", file);
            });

            if (isEdit) {
                await axios.put(
                    `${API_BASE_URL}/pettycash/update/${formData.id}`,
                    form,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                toast.success("Transaction updated");
            } else {
                await axios.post(
                    `${API_BASE_URL}/pettycash/transaction/simple`,
                    form,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                toast.success("Transaction added");
            }

            setShowModal(false);
            resetForm();
            fetchTransactions();

        } catch (e) {
            const msg = e.response?.data?.message;

            if (msg === "NO_CASHBOOK") {
                const confirm = window.confirm(
                    "No CashBook found. Do you want to request one?"
                );

                if (confirm) {
                    localStorage.setItem("openCashbookRequest", formData.category);

                    navigate("/pettycash/cashbook");
                }
            } else {
                toast.error(msg || "Error");
            }
        }
    };

    const resetForm = () => {
        setFormData({
            id: "",
            category: "",
            type: "Payment",
            amount: "",
            description: "",
            attachments: []
        });
    };

    const columns = [
        {
            field: "transaction_code",
            headerName: "Code",
            flex: 1,
            renderCell: (p) => {

                // ✅ EXPANDED
                if (p.row.isExpandedRow) {

                    const list = p.row.parent?.related_transactions || [];

                    return (
                        <div className="w-full p-4 bg-gray-50 border rounded space-y-3">

                            <div className="font-semibold mb-3">
                                Related Transactions
                            </div>

                            {list.length > 0 ? (
                                list.map((t, i) => {
                                    const tx = t.transaction_id || {};
                                    const attachments = Array.isArray(tx.attachments) ? tx.attachments : [];

                                    return (
                                        <div key={i} className="border rounded p-3 bg-white shadow-sm">
                                            <div className="flex justify-between mb-2">
                                                <span className="font-medium">
                                                    {tx?.transaction_code}
                                                </span>

                                                <span className="text-red-600">
                                                    Rs {t.reimbursed_amount}
                                                </span>
                                            </div>

                                            <div className="flex gap-2 flex-wrap">

                                                {attachments.length > 0 ? (
                                                    attachments.map((a, idx) => {

                                                        const clean = a.replace(/\\/g, "/").replace(/^\/+/, "");
                                                        const fileUrl = `${IMAGE_BASE_URL}/${clean}`;

                                                        if (a.endsWith(".pdf")) {
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onClick={() => setPreviewFile({ url: fileUrl, type: "pdf" })}
                                                                    className="px-2 py-1 bg-blue-100 text-blue-600 text-xs rounded cursor-pointer hover:bg-blue-200"
                                                                >
                                                                    PDF
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <img
                                                                key={idx}
                                                                src={fileUrl}
                                                                alt=""
                                                                onClick={() => setPreviewFile({ url: fileUrl, type: "image" })}
                                                                className="w-14 h-14 object-cover rounded border cursor-pointer hover:scale-110 transition"
                                                            />
                                                        );
                                                    })
                                                ) : (
                                                    <span className="text-gray-400 text-xs">No files</span>
                                                )}

                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-gray-400 text-sm">
                                    No related transactions
                                </div>
                            )}

                        </div>
                    );
                }

                // ✅ NORMAL ROW
                return (
                    <div className="flex items-center gap-2">

                        {(p.row.transaction_type === "Reimbursement" ||
                            p.row.transaction_type === "IOU") && (

                            <span
                                onClick={() => {
                                    setExpandedRow(prev => ({
                                        ...prev,
                                        [p.row._id]: !prev[p.row._id]
                                    }));
                                }}
                                className="cursor-pointer"
                            >
                    {expandedRow[p.row._id]
                        ? <FaChevronDown size={12} />
                        : <FaChevronRight size={12} />
                    }
                </span>
                        )}

                        <span>{p.value}</span>
                    </div>
                );
            }
        },
        {
            field: "category",
            headerName: "Category",
            flex: 1 ,
            renderCell: p => {
                if (p.row.isExpandedRow) return "";
                return p.row.category?.category_name || "-";
            }
        },
        {
            field: "type",
            headerName: "Type",
            flex: 1,
            renderCell: p => {
                if (p.row.isExpandedRow) return "";
                const type = p.row.transaction_type;

                if (type === "CashInvoice") return "Payment";
                if (type === "CashReceipt") return "Receipt";
                if (type === "Reimbursement") return "Reimbursement";
                if (type === "IOU") return "IOU";

                return (
                    <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs">
                        {type}
                    </span>
                );
            }
        },

        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            renderCell: p => {
                if (p.row.isExpandedRow) return "";
                const type = p.row.transaction_type;
                const isApproved = p.row.approval_status === "Approved";

                const isDecrease =
                    isApproved && type === "Reimbursement";

                const isIncrease =
                    isApproved &&
                    type === "Claim" &&
                    p.row.claim_payment_status === "MoneyIssued";

                return (
                    <span className={
                        isDecrease ? "text-red-600" :
                            isIncrease ? "text-green-600" :
                                "text-gray-400"
                    }>
                        {isDecrease ? "-" : isIncrease ? "+" : ""} Rs {p.row.amount}
                    </span>
                );
            }
        },

        {
            field: "opening",
            headerName: "Opening",
            flex: 1,
            renderCell: p => {
                if (p.row.isExpandedRow) return "";
                return p.row.running_opening_balance ?? "-"
            }
        },
        {
            field: "closing",
            headerName: "Current Balance",
            flex: 1,
            renderCell: p => {
                if (p.row.isExpandedRow) return "";

                return (
                    <span className="text-green-600 font-semibold">
                    Rs {p.row.running_remaining_balance ?? "-"}
                </span>
                );
            }
        },

        { field: "description", headerName: "Description", flex: 1 , renderCell: p => {
            if (p.row.isExpandedRow) return "";
            return p.row.description || "-"
            } },

        {
            field: "attachments",
            headerName: "Files",
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: p => {
                if (p.row.isExpandedRow) return "";
                return (
                    <div className="flex gap-2 item-center justify-center">
                        {p.row.attachments?.length > 0 ? (
                            p.row.attachments.map((a, i) => {
                                const cleanPath = a.replace(/\\/g, "/").replace(/^\/+/, "");
                                const fileUrl = `${IMAGE_BASE_URL}/${cleanPath}`;

                                return a?.endsWith(".pdf") ? (
                                    <a
                                        key={i}
                                        href={fileUrl}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-blue-600 text-xs underline flex items-center"
                                    >
                                        PDF
                                    </a>
                                ) : (
                                    <img
                                        key={i}
                                        src={fileUrl}
                                        alt=""
                                        className="w-10 h-10 object-cover rounded border cursor-pointer hover:scale-110 transition flex items-center"
                                        onClick={() => window.open(fileUrl, "_blank")}
                                    />
                                );
                            })
                        ) : (
                            "-"
                        )}
                    </div>
                )
            }
        },

        {
            field: "date",
            headerName: "Date",
            flex: 1,
            renderCell: p =>{
                if (p.row.isExpandedRow) return "";
                return  new Date(p.row.transaction_date).toLocaleDateString()
            }
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            renderCell: (params) => {
                if (params.row.isExpandedRow) return "";
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <button
                            onClick={() => handleEdit(params.row)}
                            className="bg-green-600 hover:bg-green-700 text-white w-8 h-8 rounded flex items-center justify-center">
                            <FaEdit />
                        </button>
                    </div>
                )
            }
        },
    ];

    const finalColumns = isAdminView
        ? columns.filter(col => col.field !== "action")
        : columns;

    return (
        <div className="p-6">

            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-green-700">
                    Transactions
                </h1>

                {
                    !isAdminView && (
                        <button
                            onClick={handledAddClick}
                            className="bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-800"
                        >
                            Add Transaction
                        </button>
                    )
                }


            </div>

            <div className="bg-white p-4 rounded-lg shadow">

                {!isAdminView && (
                    <div className= "flex justify-between mb-4">
                        <input
                            placeholder="Search"
                            className="border p-2 flex-1"
                            onChange={e => updateFilter({ search: e.target.value })}
                        />

                        <select
                            onChange={e => updateFilter({ category: e.target.value })}
                            className="border p-2"
                        >
                            <option value="">All Categories</option>
                            {categories.map(c => (
                                <option key={c._id} value={c._id}>
                                    {c.category_name}
                                </option>
                            ))}
                        </select>

                        <select
                            onChange={e => updateFilter({ type: e.target.value })}
                            className="border p-2"
                        >
                            <option value="">All</option>
                            <option value="Payment">Payment</option>
                            <option value="Receipt">Receipt</option>
                        </select>

                        <input type="date" onChange={e => updateFilter({ from: e.target.value })} className="border p-2" />
                        <input type="date" onChange={e => updateFilter({ to: e.target.value })} className="border p-2" />

                    </div>
                )}

                {isAdminView ? (
                    <div className="space-y-2">

                        {data.map(user => {
                            return (
                                <div key={user._id} className="border rounded-lg overflow-hidden">

                                    <div
                                        onClick={() => handleUserRowClick(user)}
                                        className={`flex justify-between items-center px-4 py-3 rounded-lg cursor-pointer transition-all duration-200
                                        ${expandedUser === user._id ? "bg-green-100 shadow-md" : "bg-gray-50 hover:bg-gray-100"}`}
                                    >

                                        <div className="flex items-center gap-3">

                                            <span className={`text-lg transition-transform duration-200 ${
                                                expandedUser === user._id ? "rotate-180" : ""
                                            }`}>
                                                {expandedUser === user._id ? "▼" : "▶"}
                                            </span>

                                            <span className="font-semibold text-gray-800">
                                                {user.username}
                                            </span>

                                            <span className="text-xs text-gray-500">
                                                ({user.role})
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-2">

                                            <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs">
                                                {user.count} Transaction
                                            </span>

                                            <span className="text-sm text-gray-600">
                                                {user.location}
                                            </span>

                                            <span className={`px-2 py-1 rounded text-xs ${
                                                user.status === "Active"
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-red-100 text-red-700"
                                            }`}>
                                                {user.status}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className={`transition-all duration-300 overflow-hidden ${
                                            expandedUser === user._id ? "max-h-[600px]" : "max-h-0"
                                        }`}
                                    >
                                        <div className="p-4 bg-white border-t">

                                            {/* 📊 SUMMARY */}
                                            <div className="mb-3 text-sm text-gray-600">
                                                Total Transactions: <b>{userTransactions.length}</b> |
                                                Total Amount: <b>
                                                Rs {
                                                userTransactions.reduce((acc, t) => {
                                                    return t.transaction_type === "CashInvoice"
                                                        ? acc - t.amount
                                                        : acc + t.amount;
                                                }, 0)
                                            }
                                            </b>
                                            </div>

                                            <div
                                                ref={containerRef}
                                                onScroll={handleScroll}
                                                style={{ maxHeight: "400px", overflowY: "auto" }}
                                                className="transition-all duration-300"
                                            >
                                                <Grid
                                                    rows={userTransactions}
                                                    columns={finalColumns}
                                                    getRowId={r => r._id}
                                                    fixedHeight={true}
                                                />

                                                {loadingMore && (
                                                    <div className="text-center py-2 text-sm text-gray-500">
                                                        Loading more...
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <Grid
                        rows={rowsWithExpand}
                        columns={columns}
                        getRowId={r => r._id}
                        rowCount={totalRows}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                    />
                )}

            </div>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

                    <div className="bg-white rounded-xl shadow-2xl w-[520px] overflow-hidden">

                        <div className="bg-green-700 text-white px-6 py-4 flex justify-between items-center">
                            <h2 className="text-lg font-semibold">
                                {isEdit ? "Edit Transaction" : "Add Transaction"}
                            </h2>

                            <button
                                onClick={()=>setShowModal(false)}
                                className="text-white text-xl font-bold"
                            >
                                ×
                            </button>
                        </div>

                        <div className="p-6 space-y-5">

                            <div>
                                <label className="block text-gray-700 mb-2 font-medium">
                                    Type
                                </label>

                                <div className="flex gap-6">

                                    <label className="flex items-center space-x-2">

                                        <input
                                            type="radio"
                                            name="type"
                                            value="Payment"
                                            checked={formData.type==="Payment"}
                                            onChange={handleChange}
                                            disabled={isEdit}
                                            className="accent-green-600"
                                        />

                                        <span>Payment</span>

                                    </label>

                                    <label className="flex items-center space-x-2">

                                        <input
                                            type="radio"
                                            name="type"
                                            value="Receipt"
                                            checked={formData.type==="Receipt"}
                                            onChange={handleChange}
                                            disabled={isEdit}
                                            className="accent-green-600"
                                        />

                                        <span>Receipt</span>

                                    </label>

                                </div>

                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2 font-medium">Category</label>

                                <div className="relative">

                                    <div
                                        onClick={() => setShowDropdown(!showDropdown)}
                                        className="w-full border p-2 rounded flex justify-between items-center cursor-pointer bg-white"
                                    >
                                        <span>
                                            {formData.category
                                                ? categories.find(c => c._id === formData.category)?.category_name
                                                : "Select Category"}
                                        </span>

                                        <span className="text-gray-400">▼</span>
                                    </div>

                                    {showDropdown && (
                                        <div className="absolute z-50 w-full bg-white border mt-1 rounded shadow max-h-60 overflow-y-auto">

                                            {categories
                                                .filter(c => c.type === formData.type)
                                                .map(cat => {
                                                    const status = categoryStatusMap[cat._id];

                                                    return (
                                                        <div
                                                            key={cat._id}
                                                            onClick={async () => {

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    category: cat._id
                                                                }));

                                                                setShowDropdown(false);

                                                                try {
                                                                    const res = await axios.get(
                                                                        `${API_BASE_URL}/cashbook/check?category=${cat._id}`,
                                                                        { headers: { Authorization: `Bearer ${token}` } }
                                                                    );

                                                                    const { hasCashBook, hasPendingRequest } = res.data;

                                                                    setCashbookStatus({ hasCashBook, hasPendingRequest });

                                                                    if (hasPendingRequest) {
                                                                        toast.warning("⚠️ CashBook request already pending for this category.");
                                                                        return;
                                                                    }

                                                                    if (!hasCashBook) {
                                                                        setSelectedCategoryForPrompt(cat._id);
                                                                        setShowCashbookPrompt(true);
                                                                    }

                                                                } catch {
                                                                    toast.error("Error checking cashbook");
                                                                }
                                                            }}
                                                            className="px-4 py-2 flex justify-between items-center hover:bg-gray-100 cursor-pointer"
                                                        >


                                                            <span>{cat.category_name}</span>


                                                            <span className={`text-xs px-2 py-1 rounded-full font-medium
                                                            ${status === "Active" && "bg-green-100 text-green-700"}
                                                            ${status === "Pending" && "bg-yellow-100 text-yellow-700"}
                                                            ${status === "Missing" && "bg-red-100 text-red-700"}`}>
                                                                {status}
                                                            </span>

                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}

                                </div>
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2 font-medium">
                                   Amount
                                </label>

                                <input
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleChange}
                                    disabled={cashbookStatus.hasPendingRequest}
                                    className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                />

                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2 font-medium">
                                    Description
                                </label>

                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    disabled={cashbookStatus.hasPendingRequest}
                                    rows="3"
                                    className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2 font-medium">
                                    Attachments
                                </label>

                                <div
                                    onDragOver={e => e.preventDefault()}
                                    onDrop={async e => {
                                        e.preventDefault();
                                        const files = Array.from(e.dataTransfer.files);
                                        handleFiles(files);
                                    }}
                                    onClick={() => document.getElementById("fileInput").click()}
                                    className="border-2 border-dashed border-gray-300 rounded-lg p-3 cursor-pointer hover:border-green-500 transition min-h-[120px]"
                                >

                                    {previewImages.length === 0 && (
                                        <div className="text-center text-gray-500 h-full flex items-center justify-center">
                                            <div>
                                                <p>
                                                    Drag & Drop or{" "}
                                                    <span className="text-green-600 font-semibold">Click to upload</span>
                                                </p>
                                                <p className="text-xs mt-1">
                                                    Images / PDF (Max 5MB)
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    <div className="flex flex-wrap gap-3">
                                        {previewImages.map((img, i) => (
                                            <div key={i} className="relative group">

                                                {img ? (
                                                    <img
                                                        src={img}
                                                        className="w-20 h-20 object-cover rounded-lg border"
                                                    />
                                                ) : (
                                                    <div className="w-20 h-20 flex items-center justify-center bg-gray-200 rounded-lg text-xs">
                                                        📄 PDF
                                                    </div>
                                                )}

                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        const newFiles = [...formData.attachments];
                                                        const newPrev = [...previewImages];

                                                        newFiles.splice(i, 1);
                                                        newPrev.splice(i, 1);

                                                        setFormData({ ...formData, attachments: newFiles });
                                                        setPreviewImages(newPrev);
                                                    }}
                                                    className="absolute -top-2 -right-2 bg-red-600 text-white w-5 h-5 text-xs rounded-full opacity-0 group-hover:opacity-100 transition"
                                                >
                                                    ×
                                                </button>

                                            </div>
                                        ))}

                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                document.getElementById("fileInput").click();
                                            }}
                                            className="w-20 h-20 flex items-center justify-center border-2 border-dashed rounded-lg text-gray-500 hover:border-green-500 hover:text-green-600 transition cursor-pointer"
                                        >
                                            <span className="text-2xl">+</span>
                                        </div>

                                    </div>

                                    {/* HIDDEN INPUT */}
                                    <input
                                        id="fileInput"
                                        type="file"
                                        multiple
                                        disabled={cashbookStatus.hasPendingRequest}
                                        accept="image/*,.pdf"
                                        className="hidden"
                                        onChange={async e => {
                                            const files = Array.from(e.target.files);
                                            handleFiles(files);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-end gap-3 pt-4 border-t">

                                <button
                                    onClick={()=>setShowModal(false)}
                                    className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleSubmit}
                                    disabled={cashbookStatus.hasPendingRequest || !cashbookStatus.hasCashBook}
                                    className={`px-5 py-2 bg-green-700 text-white rounded-lg hover:bg-green-800 ${
                                        cashbookStatus.hasPendingRequest
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-green-700 hover:bg-green-800 text-white"
                                    }`}
                                >
                                    Save
                                </button>
                            </div>

                        </div>

                    </div>

                </div>
            )}

            {showCashbookPrompt && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

                    <div className="bg-white rounded-2xl shadow-2xl w-[400px] p-6 text-center">

                        <div className="text-yellow-500 text-4xl mb-3">
                            ⚠️
                        </div>

                        <h2 className="text-xl font-semibold mb-2">
                            No CashBook Found
                        </h2>

                        <p className="text-gray-600 mb-6">
                            This category doesn't have a CashBook yet.
                            Do you want to request one?
                        </p>

                        <div className="flex justify-center gap-3">

                            <button
                                onClick={() => {
                                    setShowCashbookPrompt(false);

                                    setFormData({
                                        id: "",
                                        category: "",
                                        type: "Payment",
                                        amount: "",
                                        description: "",
                                        attachments: []
                                    });
                                }}
                                className="px-4 py-2 bg-gray-300 rounded-lg"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => {
                                    handleContentChange("cashbook", {
                                        openRequestModal: true,
                                        categoryId: selectedCategoryForPrompt
                                    });
                                }}
                                className="px-4 py-2 bg-green-600 text-white rounded-lg"
                            >
                                Request CashBook
                            </button>

                        </div>
                    </div>
                </div>
            )}

            {previewFile && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]"
                    onClick={() => setPreviewFile(null)}
                >
                    <div
                        className="bg-white rounded-xl p-3 max-w-[90%] max-h-[90%] relative shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* CLOSE BUTTON */}
                        <button
                            onClick={() => setPreviewFile(null)}
                            className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-600"
                        >
                            ✕
                        </button>

                        {/* IMAGE */}
                        {previewFile.type === "image" && (
                            <img
                                src={previewFile.url}
                                alt=""
                                className="max-h-[80vh] max-w-full object-contain rounded"
                            />
                        )}

                        {/* PDF */}
                        {previewFile.type === "pdf" && (
                            <iframe
                                src={previewFile.url}
                                title="PDF"
                                className="w-[80vw] h-[80vh] rounded"
                            />
                        )}
                    </div>
                </div>
            )}

        </div>
    );
}

export default TransactionPage;